import * as React from 'react';
import { useIntl } from 'react-intl';
import { IHeadProps } from '../TableHead';
import { getRequest } from '../../../Services/HttpService';
import { AxiosResponse } from 'axios';

const RESPONSE_OK = 'OK';

interface IComponentProps {
  label: boolean;
  action?: (title: string, e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
  stateStartMin: number | string;
  stateStartMax: number | string;
  stateMin: number | string;
  stateMax: number | string;
  setStateValue: (
    event: React.ChangeEvent<HTMLInputElement>,
    key: string,
    val: string | number | null,
    name: string
  ) => void;
  menuNameOpen: {
    [key: string]: boolean;
  };
}

type Props = IHeadProps & IComponentProps;

const Suggestion: React.FC<Props> = ({ ...props }) => {
  const { formatMessage: f } = useIntl();

  const [filter, setFilter] = React.useState<any>([]);
  const [inputValue, setInputValue] = React.useState<string>('');

  const handleInputValue = (e: any) => {
    const { columns, filterComponent } = props;
    setInputValue(e.target.value);
    props.setStateValue(e, columns?.name || '', null, filterComponent?.type || '');
  };

  const getData = async () => {
    const { columns, filterComponent } = props;
    if (columns && columns.filter && columns.filter.requestLink) {
      const response: AxiosResponse | false = await getRequest(
        columns.filter.requestLink.replace(
          '{term}',
          props.parentState[filterComponent?.type || ''][columns.name]
        ),
        { returnAxiosResponse: true }
      );
      if (response && response.status === 200) {
        setFilter(response.data.records);
      }
    }
  };

  const actionOpen = (e: any) => {
    props.actionOpen(e, props.columns?.name || '');
  };

  const actionSave = (e: any) => {
    const { columns, filterComponent } = props;
    const value = Number(e.currentTarget.getAttribute('data-value'));
    props.actionSave(
      columns?.name || '',
      value,
      e,
      filterComponent?.type || '',
      columns?.title || ''
    );
  };

  const action = (e: any) => {
    if (props.action) {
      props.action(props.columns?.name || '', e);
    }
  };

  const { columns, filterComponent } = props;
  if (
    columns &&
    columns.filter &&
    columns.filter.minLength &&
    props.parentState[filterComponent?.type || ''][columns.name] !== undefined &&
    props.parentState[filterComponent?.type || ''][columns.name].length >=
      columns.filter.minLength &&
    props.menuNameOpen[columns.name] !== undefined
  ) {
    getData();
  } else if (filterComponent?.selectedValue !== null && filter.length === 0) {
    setFilter([filterComponent?.selectedValue]);
  }
  return (
    <div
      data-cy={`suggestion-popup-${columns?.name}`}
      className={`label ${props.label ? 'label-primary mb-xs position-relative label--filter' : ''} ${
        props.menuNameOpen[props.columns?.name || ''] === props.label ? 'open' : ''
      }`}
      style={{ padding: !props.label ? '0px' : '9px 8px 8px 8px' }}
    >
      {props.label && (
        <span onClick={actionOpen}>
          <a
            href="#"
            title={f({ id: 'table.filter.button' })}
            data-cy="suggestion-filter-button"
            className="dropdown-toggle text-white text-decoration-none"
            id="dropdownMenu13"
            data-toggle="dropdown"
            aria-haspopup="true"
            aria-expanded="true"
          >
            {columns?.title}:{filterComponent?.selectedValue}
          </a>
          <a
            href="#"
            data-cy="suggestion-filter-remove"
            title={f({ id: 'table.filter.remove' })}
            className="text-white"
            onClick={action}
            style={{ padding: '8px', margin: '-8px -8px -8px 0' }}
          >
            <i className="cmd-icon cmd-icon-remove-sm" />
          </a>
        </span>
      )}
      <div
        className="dropdown-menu dropdown-menu-custom fs-2 js-dropdown-keep-open"
        aria-labelledby="dropdownMenu10"
      >
        <div className="pt-1 pb-2 px-2 border-bottom-on open">
          <div
            className=" form-control-labels"
            style={{ background: '#fff', border: 'none', color: '#555', padding: '0px' }}
          >
            <input
              type="text"
              autoFocus={true}
              data-cy="suggestion-filter-input"
              placeholder={
                filterComponent?.selectedValue !== null ? '' : filterComponent.placeholder
              }
              className="form-control font-weight-normal fs-2"
              defaultValue={filterComponent?.selectedValue}
              value={
                props.parentState[filterComponent?.type || ''][columns?.name || ''] === null
                  ? filterComponent?.selectedValue
                  : props.parentState[filterComponent?.type || ''][columns?.name || '']
              }
              onChange={handleInputValue}
            />
          </div>
        </div>
        {filter && filter.length > 0 ? (
          filter.map((i: any, index: any) => (
            <div
              key={index}
              style={{
                cursor: 'pointer',
                backgroundColor: filterComponent?.selectedValue === i ? 'rgb(242, 249, 255)' : '',
              }}
              className={`px-2 py-1 d-block text-black font-weight-normal ${
                index % 2 !== 0 ? 'bg-gray-light' : ''
              }`}
              onClick={actionSave}
              data-value={i}
            >
              {i}
            </div>
          ))
        ) : filterComponent?.minLength && inputValue.length < filterComponent.minLength ? (
          <div style={{ color: '#666', padding: '3px' }}>
            &nbsp;
            {f({ id: 'form.stringMin' })}
            {filterComponent.minLength}
          </div>
        ) : (
          <div style={{ color: '#666', padding: '3px' }}>
            &nbsp;
            {f({ id: 'tripsOverview.modal.noData' })}
          </div>
        )}
      </div>
    </div>
  );
};

export default Suggestion;
